package com.daytimegaming.ourdailyfinances.data.network.service

import com.daytimegaming.ourdailyfinances.BuildKonfig
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.engine.HttpClientEngine
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.request.get
import io.ktor.client.request.parameter
import io.ktor.http.ContentType
import io.ktor.serialization.kotlinx.json.json
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json

@Serializable
data class GeoApifyAutocompleteResponse(
    val features: List<GeoApifyFeature> = emptyList()
)

@Serializable
data class GeoApifyFeature(
    val properties: GeoApifyProperties
)

@Serializable
data class GeoApifyProperties(
    @SerialName("address_line1") val addressLine1: String? = null,
    @SerialName("address_line2") val addressLine2: String? = null,
    val city: String? = null,
    val state: String? = null,
    @SerialName("state_code") val stateCode: String? = null,
    val postcode: String? = null,
    val county: String? = null,
    val formatted: String? = null
)

class GeoApifyService(engine: HttpClientEngine) {
    private val client = HttpClient(engine) {
        install(ContentNegotiation) {
            json(Json {
                ignoreUnknownKeys = true
                isLenient = true
            }, contentType = ContentType.Any)
        }
    }

    suspend fun autocomplete(text: String): GeoApifyAutocompleteResponse {
        val apiKey = BuildKonfig.GEOAPIFY_API_KEY
        if (apiKey.isBlank()) {
            return GeoApifyAutocompleteResponse()
        }
        return client.get("https://api.geoapify.com/v1/geocode/autocomplete") {
            parameter("text", text)
            parameter("filter", "countrycode:us")
            parameter("apiKey", apiKey)
        }.body()
    }
}
